import { Box, Flex } from '@chakra-ui/react';
import { useRef } from 'react';
import { useRealtimeChatContext } from 'src/contexts/app/RealtimeChatProvider';
import Header from './header';
import Messages from './messages';
import Actions from './actions';
import { useBreakpointValue } from '@chakra-ui/react';

const HEADER_HEIGHT = '50px';

const AssistantChat = () => {
	const { messages } = useRealtimeChatContext();
	const paddingBottom = useBreakpointValue({ base: '170px', md: '92px' });
	const chatBoxRef = useRef<HTMLDivElement>(null);

	return (
		<Box
			ref={chatBoxRef}
			position="fixed"
			right={0}
			top={0}
			h={'100vh'}
			w={'100vw'}
			zIndex={2000}
			bg="white"
			boxShadow="lg"
			borderLeftWidth="1px"
			borderColor="#CDCDCD"
		>
			<Flex cursor={'default'} direction="column" h="full">
				<Header height={HEADER_HEIGHT} />

				<Box
					flex="1"
					padding="1rem"
					overflow="auto"
					pb={paddingBottom}
					style={{ scrollPaddingBottom: '170px' }}
				>
					<Messages conversation={messages ?? []} />
				</Box>

				<Actions />
			</Flex>
		</Box>
	);
};

export default AssistantChat;
